import { render } from "./AddVendorPayment.vue?vue&type=template&id=ecd8a03e"
import script from "./AddVendorPayment.vue?vue&type=script&lang=js"
export * from "./AddVendorPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__